var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-5",attrs:{"id":"inscription"}},[_vm._m(0),_c('profile-form')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-title"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h3',[_c('i',{staticClass:"bi bi-person-fill mr-3"}),_vm._v("Inscription")]),_c('div',{staticClass:"underline"})])])])])
}]

export { render, staticRenderFns }